import { Drawer } from "@mantine/core";

import { useGetDarkMode } from "_common/hooks/global";
import { dark, light }    from "_styles/theme";

const component = props => {
	const {
		children,
		onClose,
		displayModal,
		opened
	} = props;

	return (
		<Drawer
			onClose         = { onClose }
			opened          = { displayModal || opened }
			position        = { "bottom" }
			styles          = { {
				content: {
					borderRadius : "1rem 1rem 0 0",
					maxWidth     : "25vw",
					height       : "fit-content"
				}
			} }
			withCloseButton = { false }
			withinPortal    = { false }
			withOverlay     = { false }
			zIndex          = { 99999 }
		>
			{children }
		</Drawer>
	);
};

export default component;
